module.exports = __webpack_public_path__ + "img/check-icon.f4820335.svg";